import React, { useState, useEffect } from 'react';
import {
  Box,
  Grid,
  Paper,
  Typography,
  TextField,
  Button,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Card,
  CardContent,
  Stepper,
  Step,
  StepLabel,
  useMediaQuery,
  Alert,
  Chip,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  InputAdornment,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {
  Delete,
  CheckCircle,
  Search,
  Edit,
  Visibility,
  Download,
  Refresh,
  PersonAdd,
  Person,
  Lock,
  Email,
  Phone,
  Business,
  Badge,
  Category,
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import Sidebar from '../../../../components/sidebars/Sidebar_hotelAdmin';
import TopNav from '../../../../components/TopNav_hotelAdmin';
import axios from 'axios';
import Swal from 'sweetalert2';

// Styled components
const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const StyledTabs = styled(Tabs)(({ theme }) => ({
  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.primary.main,
    height: 3,
    borderRadius: '3px 3px 0 0',
  },
}));

const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '14px',
  minWidth: 120,
  color: theme.palette.text.secondary,
  '&.Mui-selected': {
    color: theme.palette.primary.main,
  },
  '&:hover': {
    color: theme.palette.primary.main,
    backgroundColor: 'transparent',
  },
}));

const StatusChip = styled(Chip)(({ theme, status }) => {
  const getColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'active':
        return theme.palette.success.main;
      case 'inactive':
        return theme.palette.error.main;
      case 'pending':
        return theme.palette.warning.main;
      case 'admin':
        return theme.palette.primary.main;
      case 'manager':
        return theme.palette.info.main;
      case 'receptionist':
        return theme.palette.secondary.main;
      default:
        return theme.palette.grey[500];
    }
  };

  return {
    backgroundColor: getColor(status),
    color: theme.palette.common.white,
    fontWeight: 'bold',
  };
});

const StaffCard = styled(Card)(({ theme }) => ({
  border: `2px solid ${theme.palette.divider}`,
  borderRadius: '12px',
  transition: 'all 0.3s ease',
  cursor: 'pointer',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: theme.shadows[8],
    borderColor: theme.palette.primary.main,
  },
}));

const HotelStaffManagement = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:768px)');
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeTab, setActiveTab] = useState(0);
  const [activeStep, setActiveStep] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filters, setFilters] = useState({
    department: '',
    userType: '',
    status: '',
  });
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [staffMembers, setStaffMembers] = useState([]);
  const [success, setSuccess] = useState(false);

  // Retrieve hotel data from localStorage (set during login)
const storedProfile = JSON.parse(localStorage.getItem('userProfile')) || {};
const hotelCode = storedProfile.hotelcode || storedProfile.hotel_code || storedProfile.hotelCode || '';
console.log('Stored Profile:', storedProfile);
console.log('Extracted Hotel Code:', hotelCode);

const [formData, setFormData] = useState({
  hotel_code: hotelCode,
  staffId: '',
  firstName: '',
  otherNames: '',
  department: '',
  phone: '',
  email: '',
  gender: '',
  userType: 'staff',
  password: '',
  confirmPassword: '',
});

  const [errors, setErrors] = useState({});

  // API URLs
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const STAFF_REGISTER_URL = `${API_BASE_URL}/hotel/staff/staff_register.php`;
  const GET_STAFF_URL = `${API_BASE_URL}/hotel/staff/get_staff.php`;
  const UPDATE_STAFF_URL = `${API_BASE_URL}/hotel/staff/update_staff.php`;
  const DELETE_STAFF_URL = `${API_BASE_URL}/hotel/staff/delete_staff.php`;

  // Available departments
  const departments = [
    'General Manager',
    'Reception',
    'Bar/Restaurant',
    'Account',
    'Store keeping',
    'Cashier',
    'Housekeeping',
    'Security',
    'Maintenance',
    'Spa',
    'Events',
    'Sales & Marketing',
    'HR',
    'ICT',
  ];

  const userTypes = [
   { value: 'General_Manager', label: 'General Manager' },
    { value: 'receptionist', label: 'Receptionist' },
    { value: 'Restaurant/Bar', label: 'Restaurant/Bar' },
    { value: 'Account', label: 'Account' },
     { value: 'Storekeeping', label: 'Store keeping' },
     { value: 'Cashier', label: 'Cashier' },

      { value: 'Requisition', label: 'Requisition' },
      { value: 'hod', label: 'HOD' },
  ];

  const genders = ['Male', 'Female'];

  const steps = [
    'Basic Information',
    'Contact Details',
    'Account Settings',
    'Review & Create'
  ];

  const tabLabels = [
    { label: 'Add Staff', icon: <PersonAdd /> },
    { label: 'Staff List', icon: <Search /> },
    { label: 'Departments', icon: <Business /> },
  ];

  // Fetch staff data when component mounts and when activeTab changes to Staff List
  useEffect(() => {
    if (activeTab === 1) {
      fetchStaffMembers();
    }
  }, [activeTab]);

  const fetchStaffMembers = async () => {
    try {
      setLoading(true);
      
      const params = new URLSearchParams();
      params.append('hotel_code', formData.hotel_code);
      
      if (filters.department) params.append('department', filters.department);
      if (filters.userType) params.append('user_type', filters.userType);
      if (searchQuery) params.append('search', searchQuery);

      const response = await axios.get(`${GET_STAFF_URL}?${params.toString()}`, {
        headers: { 
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        timeout: 15000,
        withCredentials: false,
      });

      if (response.data.success) {
        setStaffMembers(response.data.staff || []);
      } else {
        throw new Error(response.data.error || 'Failed to fetch staff data');
      }
    } catch (error) {
      console.error('Error fetching staff:', error);
      handleApiError(error, 'Failed to load staff data');
    } finally {
      setLoading(false);
    }
  };

  const handleApiError = (error, defaultMessage) => {
    console.error('Full error details:', error);
    
    let errorMessage = defaultMessage;
    
    if (error.code === 'ECONNABORTED') {
      errorMessage = "Request timeout. Please check your connection and try again.";
    } else if (error.response) {
      errorMessage = error.response.data?.error || error.response.data?.message || `Server error: ${error.response.status}`;
    } else if (error.request) {
      console.error('No response received - CORS issue likely:', error.request);
      errorMessage = "Network error. This may be a CORS issue. Check browser console for details.";
    } else {
      errorMessage = error.message;
    }
    
    Swal.fire({
      title: "Error",
      text: errorMessage,
      icon: "error",
      confirmButtonText: "OK",
    });
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleInputChange = (field) => (event) => {
    const value = event.target.value;
    setFormData({
      ...formData,
      [field]: value
    });

    if (errors[field]) {
      setErrors({
        ...errors,
        [field]: ''
      });
    }
  };

  const validateStep = (step) => {
    const newErrors = {};

    switch (step) {
      case 0:
        if (!formData.firstName) newErrors.firstName = 'First name is required';
        if (!formData.department) newErrors.department = 'Department is required';
        break;
      
      case 1:
        if (!formData.phone) newErrors.phone = 'Phone number is required';
        if (!formData.email) newErrors.email = 'Email is required';
        else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Email is invalid';
        break;
      
      case 2:
        if (!formData.password) newErrors.password = 'Password is required';
        else if (formData.password.length < 6) newErrors.password = 'Password must be at least 6 characters';
        if (!formData.confirmPassword) newErrors.confirmPassword = 'Please confirm password';
        else if (formData.password !== formData.confirmPassword) newErrors.confirmPassword = 'Passwords do not match';
        break;
      
      default:
        break;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const generateStaffId = () => {
  const timestamp = Date.now().toString(36); // Base36 timestamp
  const randomStr = Math.random().toString(36).substring(2, 6).toUpperCase(); // Random string
  return `STAFF${timestamp}${randomStr}`;
};

  const handleNext = () => {
    if (validateStep(activeStep)) {
      if (activeStep === 0 && !formData.staffId) {
        setFormData(prev => ({
          ...prev,
          staffId: generateStaffId()
        }));
      }
      setActiveStep((prev) => prev + 1);
    }
  };

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };

  const handleSubmit = async () => {
    // Add hotel_code validation
  if (!formData.hotel_code) {
    Swal.fire({
      title: "Error",
      text: "Hotel code is missing. Please log in again.",
      icon: "error",
      confirmButtonText: "OK",
    });
    return;
  }
if (!validateStep(activeStep)) {
    Swal.fire({
      title: "Validation Error",
      text: "Please fix the errors in the form",
      icon: "error",
      confirmButtonText: "OK",
    });
    return;
  }

    if (!validateStep(activeStep)) {
      Swal.fire({
        title: "Validation Error",
        text: "Please fix the errors in the form",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    setLoading(true);

    try {
      const submitData = {
        hotel_code: formData.hotel_code,
        staff_id: formData.staffId,
        first_name: formData.firstName,
        other_names: formData.otherNames,
        department: formData.department,
        phone: formData.phone,
        email: formData.email,
        gender: formData.gender,
        user_type: formData.userType,
        password: formData.password,
      };

      console.log('Submitting staff data:', submitData);
      
      const response = await axios.post(STAFF_REGISTER_URL, submitData, {
        headers: { 
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        timeout: 15000,
        withCredentials: false,
      });

      console.log('Staff registration response:', response.data);

      if (response.data.success) {
        Swal.fire({
          title: "Success!",
          text: "Staff member registered successfully!",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          setSuccess(true);
          setActiveTab(1); // Switch to Staff List tab
          setActiveStep(0); // Reset form
          setFormData({
            hotel_code: formData.hotel_code,
            staffId: '',
            firstName: '',
            otherNames: '',
            department: '',
            phone: '',
            email: '',
            gender: 'Other',
            userType: 'staff',
            password: '',
            confirmPassword: '',
          });
          fetchStaffMembers(); // Refresh the staff list
        });
      } else {
        throw new Error(response.data.error || 'Registration failed');
      }

    } catch (error) {
      handleApiError(error, "Failed to register staff member");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleFilterChange = (filter) => (event) => {
    setFilters(prev => ({
      ...prev,
      [filter]: event.target.value
    }));
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleEditStaff = (staff) => {
    setSelectedStaff(staff);
    setEditDialogOpen(true);
  };

  const handleViewStaff = (staff) => {
    setSelectedStaff(staff);
    setViewDialogOpen(true);
  };

  const handleDeleteStaff = async (staffId) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel"
    });

    if (result.isConfirmed) {
      try {
        setLoading(true);
        
        const response = await axios.delete(DELETE_STAFF_URL, {
          data: { id: staffId },
          headers: { 
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
          timeout: 15000,
          withCredentials: false,
        });

        if (response.data.success) {
          Swal.fire({
            title: "Deleted!",
            text: "Staff member has been deleted.",
            icon: "success",
            confirmButtonText: "OK",
          });
          fetchStaffMembers(); // Refresh the list
        } else {
          throw new Error(response.data.error || 'Deletion failed');
        }
      } catch (error) {
        handleApiError(error, "Failed to delete staff member");
      } finally {
        setLoading(false);
      }
    }
  };

  const handleUpdateStaff = async () => {
    if (!selectedStaff) return;

    try {
      setLoading(true);
      
      const updateData = {
        id: selectedStaff.id,
        staff_id: selectedStaff.staff_id,
        first_name: selectedStaff.first_name,
        other_names: selectedStaff.other_names,
        department: selectedStaff.department,
        phone: selectedStaff.phone,
        email: selectedStaff.email,
        gender: selectedStaff.gender,
        user_type: selectedStaff.user_type,
      };

      const response = await axios.put(UPDATE_STAFF_URL, updateData, {
        headers: { 
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        timeout: 15000,
        withCredentials: false,
      });

      if (response.data.success) {
        Swal.fire({
          title: "Success!",
          text: "Staff member updated successfully!",
          icon: "success",
          confirmButtonText: "OK",
        });
        setEditDialogOpen(false);
        setSelectedStaff(null);
        fetchStaffMembers(); // Refresh the list
      } else {
        throw new Error(response.data.error || 'Update failed');
      }
    } catch (error) {
      handleApiError(error, "Failed to update staff member");
    } finally {
      setLoading(false);
    }
  };

  const handleRefresh = () => {
    fetchStaffMembers();
  };

  const filteredStaff = staffMembers.filter(staff => 
    staff.first_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    staff.other_names?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    staff.staff_id?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    staff.email?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    staff.department?.toLowerCase().includes(searchQuery.toLowerCase())
  ).filter(staff => 
    (filters.department ? staff.department === filters.department : true) &&
    (filters.userType ? staff.user_type === filters.userType : true)
  );

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userProfile');
    navigate('/Entri');
  };

  const handleNotificationClick = () => {
    alert('You have new notifications!');
  };

  const renderAddStaffTab = () => (
    <Paper elevation={3} sx={{ p: 4, mt: 2 }}>
      <Typography variant="h4" gutterBottom align="center" color="primary" sx={{ mb: 1 }}>
        Staff Registration
      </Typography>
      <Typography variant="subtitle1" gutterBottom align="center" color="textSecondary" sx={{ mb: 4 }}>
        Register new staff members with their roles and permissions
      </Typography>

      {success && (
        <Alert severity="success" sx={{ mb: 3 }}>
          Staff member created successfully! Redirecting to staff list...
        </Alert>
      )}

      <Stepper activeStep={activeStep} sx={{ mb: 4, mt: 2 }}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      <Box sx={{ mb: 4 }}>
        {renderStepContent(activeStep)}
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Button
          onClick={handleBack}
          disabled={activeStep === 0 || loading}
          variant="outlined"
        >
          Back
        </Button>

        {activeStep === steps.length - 1 ? (
          <Button
            onClick={handleSubmit}
            variant="contained"
            color="primary"
            size="large"
            startIcon={<CheckCircle />}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : 'Create Staff Account'}
          </Button>
        ) : (
          <Button
            onClick={handleNext}
            variant="contained"
            color="primary"
            disabled={loading}
          >
            Next
          </Button>
        )}
      </Box>
    </Paper>
  );

  const renderStaffListTab = () => (
    <Box sx={{ mt: 2 }}>
      <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
          <TextField
            placeholder="Search by name, staff ID, email, or department..."
            value={searchQuery}
            onChange={handleSearch}
            sx={{ flexGrow: 1, minWidth: 300 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search color="action" />
                </InputAdornment>
              ),
            }}
          />
          <FormControl sx={{ minWidth: 150 }}>
            <InputLabel>Department</InputLabel>
            <Select
              value={filters.department}
              onChange={handleFilterChange('department')}
              label="Department"
            >
              <MenuItem value="">All Departments</MenuItem>
              {departments.map(dept => (
                <MenuItem key={dept} value={dept}>{dept}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ minWidth: 150 }}>
            <InputLabel>Role</InputLabel>
            <Select
              value={filters.userType}
              onChange={handleFilterChange('userType')}
              label="Role"
            >
              <MenuItem value="">All Roles</MenuItem>
              {userTypes.map(type => (
                <MenuItem key={type.value} value={type.value}>{type.label}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button 
            variant="outlined" 
            startIcon={<Refresh />}
            onClick={handleRefresh}
            disabled={loading}
          >
            Refresh
          </Button>
          <Button variant="contained" startIcon={<Download />}>
            Export
          </Button>
        </Box>
      </Paper>

      <TableContainer component={Paper} elevation={3}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: 'primary.main' }}>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Staff ID</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Name</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Department</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Contact</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Role</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Date Created</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                  <CircularProgress />
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    Loading staff data...
                  </Typography>
                </TableCell>
              </TableRow>
            ) : filteredStaff.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                  <Typography variant="body2" color="textSecondary">
                    No staff members found
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              filteredStaff
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((staff) => (
                  <TableRow key={staff.id} hover>
                    <TableCell>
                      <Chip 
                        label={staff.staff_id} 
                        variant="outlined" 
                        size="small"
                        color="primary"
                      />
                    </TableCell>
                    <TableCell>
                      <Typography fontWeight="medium">
                        {staff.first_name} {staff.other_names}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        {staff.gender}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Chip 
                        label={staff.department} 
                        size="small"
                        variant="outlined"
                      />
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">{staff.phone}</Typography>
                      <Typography variant="body2" color="textSecondary">
                        {staff.email}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <StatusChip 
                        label={staff.user_type} 
                        status={staff.user_type}
                        size="small"
                      />
                    </TableCell>
                    <TableCell>{staff.date_created}</TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <IconButton 
                          size="small" 
                          color="primary"
                          onClick={() => handleViewStaff(staff)}
                        >
                          <Visibility />
                        </IconButton>
                        <IconButton 
                          size="small" 
                          color="secondary"
                          onClick={() => handleEditStaff(staff)}
                        >
                          <Edit />
                        </IconButton>
                        <IconButton 
                          size="small" 
                          color="error"
                          onClick={() => handleDeleteStaff(staff.id)}
                        >
                          <Delete />
                        </IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
            )}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredStaff.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
    </Box>
  );

  const renderDepartmentsTab = () => (
    <Box sx={{ mt: 2 }}>
      <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          Department Overview
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <InputLabel>Filter by Department</InputLabel>
              <Select
                value={filters.department}
                onChange={handleFilterChange('department')}
                label="Filter by Department"
              >
                <MenuItem value="">All Departments</MenuItem>
                {departments.map(dept => (
                  <MenuItem key={dept} value={dept}>{dept}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Paper>

      <Grid container spacing={3}>
        {departments.map((department) => {
          const deptStaff = staffMembers.filter(staff => staff.department === department);
          
          return (
            <Grid item xs={12} md={6} lg={4} key={department}>
              <StaffCard>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Business color="primary" sx={{ mr: 2 }} />
                    <Typography variant="h6">{department}</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography variant="body2" color="textSecondary">
                      Total Staff:
                    </Typography>
                    <Typography variant="body2" fontWeight="bold">
                      {deptStaff.length}
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                    <Typography variant="body2" color="textSecondary">
                      Roles:
                    </Typography>
                    <Box>
                      {userTypes.map(type => {
                        const count = deptStaff.filter(staff => staff.user_type === type.value).length;
                        return count > 0 ? (
                          <Chip 
                            key={type.value}
                            label={`${type.label}: ${count}`}
                            size="small"
                            sx={{ ml: 0.5, mb: 0.5 }}
                          />
                        ) : null;
                      })}
                    </Box>
                  </Box>
                  <Button 
                    variant="outlined" 
                    fullWidth 
                    size="small"
                    onClick={() => {
                      setFilters(prev => ({ ...prev, department }));
                      setActiveTab(1);
                    }}
                  >
                    View Staff
                  </Button>
                </CardContent>
              </StaffCard>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );

  const renderStepContent = (step) => {
    switch (step) {
     case 0:
  return (
    <Box>
      {/* Section Heading */}
      <Typography
        variant="h5"
        color="primary"
        fontWeight={600}
        gutterBottom
        sx={{ mb: 2 }}
      >
        Basic Information
      </Typography>

      {/* Form Fields */}
      <Grid container spacing={3}>
        {/* Staff ID */}
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            required
            label="Staff ID"
            value={formData.staffId}
            onChange={handleInputChange('staffId')}
            error={!!errors.staffId}
            helperText={errors.staffId || 'Auto-generated if left empty'}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Badge color="action" />
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        {/* First Name */}
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            required
            label="First Name"
            value={formData.firstName}
            onChange={handleInputChange('firstName')}
            error={!!errors.firstName}
            helperText={errors.firstName}
          />
        </Grid>

        {/* Other Names */}
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Other Names"
            value={formData.otherNames}
            onChange={handleInputChange('otherNames')}
          />
        </Grid>

        {/* Gender */}
        <Grid item xs={12} md={6}>
          <FormControl
            fullWidth
            required
            error={!!errors.gender}
            sx={{ minWidth: 200 }}
          >
            <InputLabel>Gender</InputLabel>
            <Select
              value={formData.gender}
              onChange={handleInputChange('gender')}
              label="Gender"
            >
              {genders.map((gender) => (
                <MenuItem key={gender} value={gender}>
                  {gender}
                </MenuItem>
              ))}
            </Select>
            {errors.gender && (
              <Typography color="error" variant="caption">
                {errors.gender}
              </Typography>
            )}
          </FormControl>
        </Grid>

        {/* Department */}
        <Grid item xs={12} md={6}>
          <FormControl
            fullWidth
            required
            error={!!errors.department}
            sx={{ minWidth: 200 }}
          >
            <InputLabel>Department</InputLabel>
            <Select
              value={formData.department}
              onChange={handleInputChange('department')}
              label="Department"
            >
              {departments.map((dept) => (
                <MenuItem key={dept} value={dept}>
                  {dept}
                </MenuItem>
              ))}
            </Select>
            {errors.department && (
              <Typography color="error" variant="caption">
                {errors.department}
              </Typography>
            )}
          </FormControl>
        </Grid>

        {/* User Type */}
        <Grid item xs={12} md={6}>
          <FormControl fullWidth sx={{ minWidth: 200 }}>
            <InputLabel>User Type</InputLabel>
            <Select
              value={formData.userType}
              onChange={handleInputChange('userType')}
              label="User Type"
            >
              {userTypes.map((type) => (
                <MenuItem key={type.value} value={type.value}>
                  {type.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  );

      case 1:
        return (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom color="primary">
                Contact Details
              </Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Phone Number *"
                value={formData.phone}
                onChange={handleInputChange('phone')}
                error={!!errors.phone}
                helperText={errors.phone}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Phone color="action" />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Email Address *"
                type="email"
                value={formData.email}
                onChange={handleInputChange('email')}
                error={!!errors.email}
                helperText={errors.email}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Email color="action" />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
        );

      case 2:
        return (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom color="primary">
                Account Settings
              </Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Password *"
                type="password"
                value={formData.password}
                onChange={handleInputChange('password')}
                error={!!errors.password}
                helperText={errors.password}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Lock color="action" />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Confirm Password *"
                type="password"
                value={formData.confirmPassword}
                onChange={handleInputChange('confirmPassword')}
                error={!!errors.confirmPassword}
                helperText={errors.confirmPassword}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Lock color="action" />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Alert severity="info" sx={{ mt: 2 }}>
                <Typography variant="body2">
                  Password must be at least 6 characters long. The staff member will use this password to log into the system.
                </Typography>
              </Alert>
            </Grid>
          </Grid>
        );

      case 3:
        return (
          <Box>
            <Typography variant="h5" gutterBottom align="center" color="primary" sx={{ mb: 4 }}>
              Review Staff Information
            </Typography>
            
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Card variant="outlined">
                  <CardContent>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <Person color="primary" sx={{ mr: 2 }} />
                      <Typography variant="h6" color="primary">
                        Personal Information
                      </Typography>
                    </Box>
                    <List dense>
                      <ListItem>
                        <ListItemText 
                          primary="Staff ID" 
                          secondary={formData.staffId}
                        />
                      </ListItem>
                      <Divider component="li" />
                      <ListItem>
                        <ListItemText 
                          primary="Full Name" 
                          secondary={`${formData.firstName} ${formData.otherNames || ''}`.trim()}
                        />
                      </ListItem>
                      <Divider component="li" />
                      <ListItem>
                        <ListItemText 
                          primary="Gender" 
                          secondary={formData.gender}
                        />
                      </ListItem>
                    </List>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} md={6}>
                <Card variant="outlined">
                  <CardContent>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <Business color="primary" sx={{ mr: 2 }} />
                      <Typography variant="h6" color="primary">
                        Work Information
                      </Typography>
                    </Box>
                    <List dense>
                      <ListItem>
                        <ListItemText 
                          primary="Department" 
                          secondary={formData.department}
                        />
                      </ListItem>
                      <Divider component="li" />
                      <ListItem>
                        <ListItemText 
                          primary="Role" 
                          secondary={userTypes.find(t => t.value === formData.userType)?.label || formData.userType}
                        />
                      </ListItem>
                    </List>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} md={6}>
                <Card variant="outlined">
                  <CardContent>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <Email color="primary" sx={{ mr: 2 }} />
                      <Typography variant="h6" color="primary">
                        Contact Information
                      </Typography>
                    </Box>
                    <List dense>
                      <ListItem>
                        <ListItemText 
                          primary="Phone" 
                          secondary={formData.phone}
                        />
                      </ListItem>
                      <Divider component="li" />
                      <ListItem>
                        <ListItemText 
                          primary="Email" 
                          secondary={formData.email}
                        />
                      </ListItem>
                    </List>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} md={6}>
                <Card variant="outlined">
                  <CardContent>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <Lock color="primary" sx={{ mr: 2 }} />
                      <Typography variant="h6" color="primary">
                        Account Information
                      </Typography>
                    </Box>
                    <List dense>
                      <ListItem>
                        <ListItemText 
                          primary="Login Email" 
                          secondary={formData.email}
                        />
                      </ListItem>
                      <Divider component="li" />
                      <ListItem>
                        <ListItemText 
                          primary="Account Type" 
                          secondary={userTypes.find(t => t.value === formData.userType)?.label || formData.userType}
                        />
                      </ListItem>
                    </List>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Box>
        );

      default:
        return null;
    }
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 0:
        return renderAddStaffTab();
      case 1:
        return renderStaffListTab();
      case 2:
        return renderDepartmentsTab();
      default:
        return renderAddStaffTab();
    }
  };

  return (
    <Box sx={{ display: 'flex' }}>
      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

      {/* Main Content */}
      <Box
        sx={{
          flexGrow: 1,
          p: 3,
          ml: isMobile ? 0 : sidebarOpen ? 30 : 5,
          mt: 0,
          maxWidth: '1400px',
          mx: 'auto',
        }}
      >
        {/* Top Navigation */}
        <TopNav
          onLogout={handleLogout}
          onNotificationClick={handleNotificationClick}
          toggleSidebar={toggleSidebar}
        />

        {/* Main Content Header */}
        <Paper elevation={2} sx={{ p: 3, mt: 3, backgroundColor: 'primary.main', color: 'white' }}>
          <Typography variant="h4" fontWeight="bold">
            Staff Management
          </Typography>
          <Typography variant="subtitle1">
            Manage hotel staff members, roles, and departments
          </Typography>
        </Paper>

        {/* Tabs Section */}
        <Paper elevation={2} sx={{ mt: 2 }}>
          <StyledTabs
            value={activeTab}
            onChange={handleTabChange}
            variant="fullWidth"
            sx={{
              borderBottom: 1,
              borderColor: 'divider',
              '& .MuiTabs-flexContainer': {
                justifyContent: 'center',
              },
            }}
          >
            {tabLabels.map((tab, index) => (
              <StyledTab
                key={index}
                label={tab.label}
                icon={tab.icon}
                iconPosition="start"
              />
            ))}
          </StyledTabs>

          {/* Tab Content */}
          <Box sx={{ p: 3 }}>
            {renderTabContent()}
          </Box>
        </Paper>

        {/* Edit Staff Dialog */}
        <Dialog 
          open={editDialogOpen} 
          onClose={() => setEditDialogOpen(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>
            Edit Staff Member
          </DialogTitle>
          <DialogContent>
            {selectedStaff && (
              <Grid container spacing={3} sx={{ mt: 1 }}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="First Name"
                    value={selectedStaff.first_name || ''}
                    onChange={(e) => setSelectedStaff({...selectedStaff, first_name: e.target.value})}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Other Names"
                    value={selectedStaff.other_names || ''}
                    onChange={(e) => setSelectedStaff({...selectedStaff, other_names: e.target.value})}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <InputLabel>Department</InputLabel>
                    <Select
                      value={selectedStaff.department || ''}
                      onChange={(e) => setSelectedStaff({...selectedStaff, department: e.target.value})}
                      label="Department"
                    >
                      {departments.map(dept => (
                        <MenuItem key={dept} value={dept}>{dept}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <InputLabel>Role</InputLabel>
                    <Select
                      value={selectedStaff.user_type || ''}
                      onChange={(e) => setSelectedStaff({...selectedStaff, user_type: e.target.value})}
                      label="Role"
                    >
                      {userTypes.map(type => (
                        <MenuItem key={type.value} value={type.value}>{type.label}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Phone"
                    value={selectedStaff.phone || ''}
                    onChange={(e) => setSelectedStaff({...selectedStaff, phone: e.target.value})}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Email"
                    value={selectedStaff.email || ''}
                    onChange={(e) => setSelectedStaff({...selectedStaff, email: e.target.value})}
                  />
                </Grid>
              </Grid>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setEditDialogOpen(false)}>Cancel</Button>
            <Button 
              onClick={handleUpdateStaff} 
              variant="contained"
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : 'Save Changes'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* View Staff Dialog */}
        <Dialog 
          open={viewDialogOpen} 
          onClose={() => setViewDialogOpen(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>
            Staff Details
          </DialogTitle>
          <DialogContent>
            {selectedStaff && (
              <List>
                <ListItem>
                  <ListItemText 
                    primary="Staff ID" 
                    secondary={selectedStaff.staff_id}
                  />
                </ListItem>
                <Divider />
                <ListItem>
                  <ListItemText 
                    primary="Full Name" 
                    secondary={`${selectedStaff.first_name} ${selectedStaff.other_names || ''}`.trim()}
                  />
                </ListItem>
                <Divider />
                <ListItem>
                  <ListItemText 
                    primary="Department" 
                    secondary={selectedStaff.department}
                  />
                </ListItem>
                <Divider />
                <ListItem>
                  <ListItemText 
                    primary="Role" 
                    secondary={userTypes.find(t => t.value === selectedStaff.user_type)?.label || selectedStaff.user_type}
                  />
                </ListItem>
                <Divider />
                <ListItem>
                  <ListItemText 
                    primary="Contact" 
                    secondary={`${selectedStaff.phone} | ${selectedStaff.email}`}
                  />
                </ListItem>
                <Divider />
                <ListItem>
                  <ListItemText 
                    primary="Gender" 
                    secondary={selectedStaff.gender}
                  />
                </ListItem>
                <Divider />
                <ListItem>
                  <ListItemText 
                    primary="Date Created" 
                    secondary={selectedStaff.date_created}
                  />
                </ListItem>
              </List>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setViewDialogOpen(false)}>Close</Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>
  );
};

export default HotelStaffManagement;